import React from 'react';
import HomeVideo from "../components/Home-video/Home-video";
import HomeTours from "../components/Home-tours/HomeTours";
import Partners from "../components/Partners/Partners";
import HomeAbroad from "../components/Home-abroad/Home-abroad";
import HomeArmenia from "../components/HomeArmenia/HomeArmenia";
import HomeEuro from "../components/Home-euro/Home-euro";
import Seo from "../components/Seo/Seo";

const HomePage = () => {
    return (
        <div className='home-page'>
            <Seo pageKey="home" />
            <HomeVideo/>
            <HomeTours/>
            <HomeAbroad/>
            <HomeEuro/>
            <HomeArmenia/>
            <Partners/>
        </div>
    );
};

export default HomePage;